import { Box, styledComponent, Button } from '@hermes/web-components'

export const ContentContainer = styledComponent(Box)(({ theme }) => ({
  marginTop: '40px',
  [theme.breakpoints.down('sm')]: {
    marginTop: '16px'
  }
}))

export const GenresContainer = styledComponent(Box)(({ theme }) => ({
  display: 'flex',
  margin: '16px 0',
  flexWrap: 'wrap',
  gap: '4px',
  [theme.breakpoints.down('xs')]: {
    flexWrap: 'nowrap',
    overflowX: 'auto'
  }
}))

export const AccordionLine = styledComponent(Box)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.neutral[200]}`,
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '16px 0'
}))

export const ShowMoreButton = styledComponent(Button)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: 400,
  letterSpacing: '-0.02em',
  paddingLeft: '8px',
  whiteSpace: 'nowrap'
}))
